/**
 *
 * FullscreenControl
 *
 */

import React from 'react';
// import styled from 'styled-components';
import fscreen from 'fscreen';
import IconButton from 'components/IconButton';
import { trackLabel } from 'utils/analytics';

/* eslint-disable react/prefer-stateless-function */
class FullscreenControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fullscreen: fscreen.fullscreenElement !== null };
    this.compress = this.compress.bind(this);
    this.expand = this.expand.bind(this);
    this.track = trackLabel({ category: 'Map', action: 'Fullscreen' });
  }

  expand() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('full-screen');
    this.setState({ fullscreen: true });
    if (fscreen.fullscreenEnabled) {
      fscreen.requestFullscreen(body);
      this.track('on');
    }
  }

  compress() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('full-screen');
    this.setState({ fullscreen: false });
    if (fscreen.fullscreenEnabled) {
      fscreen.exitFullscreen();
      this.track('off');
    }
  }

  render() {
    const { fullscreen } = this.state;
    return fullscreen ? (
      <IconButton
        icon="compress"
        className="btn-fab"
        aria-label="Compress map"
        onClick={this.compress}
      />
    ) : (
      <IconButton
        icon="expand"
        className="btn-fab"
        aria-label="Expand map"
        onClick={this.expand}
      />
    );
  }
}

FullscreenControl.propTypes = {};

export default FullscreenControl;
